import { createContext } from 'react';
import { UploadingFile } from '~/hooks/dataset/useDatasetFileUploader';

interface StorageContextValues {
  lastClickedItem: string | null;
  uploadingFiles: Map<string, UploadingFile>;
  handleUploadedFiles: (files: File[] | null, folderPath: string) => Promise<void>;
  isFilesUploading: boolean;
}

const StorageContext = createContext<StorageContextValues | null>(null);

export default StorageContext;
